import { useContext } from 'react';

import { HistogramChartStateContext } from '../../contexts/HistogramChartState.context.js';

export const useSetState = () => {
  const { setState } = useContext(HistogramChartStateContext);

  return setState;
};
